import axios from "axios";
import { mapSizesToProducts } from "../../../src/utils/mapSizesToProduct";
import { useRouter } from "next/router";
import { NewProductCard } from "../../../src/components/newProductCard";
import { gql } from "graphql-tag";
import { parse } from "cookie";
import { categoryValues } from "../category.json";
import { getLocationDetail } from "../../../api.services.js/catalouge";
import UnbxdProductCard from "../../../src/UnbxdProductCard";
import ProductCard from "../../../src/productCard";
import client from "../../../graphqlClient";
import Category from "../../../src/components/category";
import { useEffect, useState } from "react";
import Head from "next/head";
import config from "../../../config";
import { breadsCrumbSchema, webPageSchema } from "../../../src/utils/tiles";
import { scrollToElement } from "../../../src/utils/scroll-to-element";

export const getProductQueryServerSide = gql`
  query Products(
    $filter: ProductAttributeFilterInput!
    $sort: ProductAttributeSortInput!
    $pageSize: Int!
    $currentPage: Int!
  ) {
    products(
      filter: $filter
      sort: $sort
      pageSize: $pageSize
      currentPage: $currentPage
    ) {
      currentcategory {
        name
        description
        dynamic_content
        imageUrl
        meta_keywords
        meta_description
        meta_title
        schema
        videoschema
        breadcrumbs {
          category_id
          category_name
          category_level
          category_url_key
          category_url_path
        }
      }
      appliedFilters {
        label
        value
        attribute_code
      }
      aggregations(filter: { category: { includeDirectChildrenOnly: true } }) {
        attribute_code
        count
        label
        options {
          label
          value
          count
          swatch_data {
            type
            value
          }
        }
      }
      subcategories {
        id
        name
        imageUrl
      }
      total_count
      items {
        id
        name
        sku
        url_key
        price_range {
          minimum_price {
            regular_price {
              value
              currency
            }
            final_price {
              value
              currency
            }
            discount {
              amount_off
              percent_off
            }
          }
          maximum_price {
            regular_price {
              value
              currency
            }
            final_price {
              value
              currency
            }
            discount {
              amount_off
              percent_off
            }
          }
        }
        extraVariables {
          skd_stock
          dora_stock
          hoskote_stock
          west_zone_stock
          tile_type
          tile_area
          factory
          finish {
            label
            value
            url_key
          }
          tile_design
          is_enabled
          is_new
          image_url
          ambience_image_url
          product_url
          tile_size
          sq_ft_price
        }
      }
      sort_fields {
        default
        options {
          value
          label
        }
      }
    }
  }
`;

const unBxdUrl =
  "?p-id=categoryPathId%3A%22%2Ftiles%2Fkitchen-tiles%22&facet.multiselect=true&spellcheck=true&pagetype=boolean&facet.multiselect=true&spellcheck=true&rows=50&version=V2&fallback=true&viewType=GRID&facet.version=V2&banner=true";

const kitchenTileSections = [
  {
    type: "Explore Kitchen Wall and Backsplash Tiles",
    name: "wall",
    label: "Wall",
    description:
      "Kitchen wall tiles are the perfect way to add a touch of elegance and style to your kitchen. They not only enhance the aesthetic appeal of the space but also provide a practical solution for protecting walls from moisture, stains, and heat. With a wide range of designs, colours, and textures available, you can easily find the perfect wall tiles that complement your kitchen decor. Whether you prefer classic ceramic tiles or modern glass mosaics, these tiles can transform your kitchen into a stylish and functional area. Explore our collection of kitchen wall tiles to find the ideal match for your home.",
  },
  {
    type: "Explore Kitchen Floor Tiles",
    name: "floor",
    label: "Floor",
    description:
      "Kitchen floor tiles are an essential element in creating a functional and stylish kitchen space. They not only provide a durable and easy-to-clean surface but also contribute to the overall aesthetic of the room. With a variety of materials, colours, and patterns available, you can choose the perfect floor tiles that suit your kitchen's design and your personal style. From classic ceramic tiles to modern porcelain and natural stone options, these tiles can enhance the beauty of your kitchen while ensuring it remains practical for everyday use. Explore our collection of kitchen floor tiles to find the ideal fit for your home.",
  },
  {
    type: "Explore Kitchen Countertop Tiles",
    name: "counter",
    description:
      "Kitchen countertop tiles are a versatile and stylish option for enhancing the look and functionality of your kitchen. These tiles not only provide a durable surface for food preparation but also add a touch of elegance to your kitchen decor. With a wide range of materials, colours, and designs available, you can easily find the perfect countertop tiles that complement your kitchen's style. Whether you prefer classic ceramic tiles or modern glass mosaics, these tiles can transform your kitchen into a beautiful and practical space. Explore our collection of kitchen countertop tiles to find the ideal match for your home.",
    label: "Countertop",
  },
];

/**
 * @function getServerSideProps
 * @description This server-side function fetches data for the Living Room Tiles page.
 *              It handles both old and new components, and the logic is branched
 *              based on presence of query params.
 * @param {Object} context - The Next.js context object.
 * @returns {Object} An object containing the props to be passed to the page component.
 * @property {boolean} oldComponent - If true, render the old component.
 * @property {Object} oldComponentProps - Props to pass to the old component.
 * @property {boolean} fromPincode - If true, fetch data based on pincode cookie.
 * @property {string} categoryValue - The category value (e.g. "tiles/kitchen-tiles").
 * @property {Object} response - The response from the Unbxd API.
 * @property {Object} sizeProductList - The size products list.
 * @property {string} error - The error message.
 */
export async function getServerSideProps(context) {
  const { query, resolvedUrl, req } = context;

  let props = {
    oldComponent: false,
    fromPincode: false,
    oldComponentProps: {},
    response: null,
    sizeProductList: null,
    error: null,
  };

  let cookies;
  let categoryValue = `tiles/kitchen-tiles`;
  let value = "";
  let PinFromCityPage;
  let fitterrss = {};
  let fitterrss2 = {};
  let unBxdProd;
  let facetsUnbxd;
  let appliedFilterFromUnbxd;
  let data;

  // staging url
  // const baseUrl = `https://search.unbxd.io/efff4c80403c9e5356384bd354272ff4/ss-unbxd-aapac-dev-orientbell53741713874300/category`;

  // prod url
  const baseUrl = `https://search.unbxd.io/5a4b9251b67027ff94d260e4ac6ac09e/ss-unbxd-aapac-prod-orientbell53741713874410/category`;

  // find the category ID & pin
  categoryValues.forEach((el) => {
    if (el.urlKey === categoryValue) {
      value = el.id;
      if (el.pin) PinFromCityPage = el.pin;
    }
  });

  // Base filter for both old & new
  fitterrss = { category_id: { in: [value] } };
  fitterrss2 = {};

  const errorArray = [
    "cat",
    "remc",
    "product_list_order",
    "product_list_dir",
    "mt",
    "trending",
    "tile_finish",
    "aor",
    "tiles_design",
    "tile_color",
    "p",
    "locations",
    ";popularity",
    "application",
    "type_finish",
    "plocation",
    ";trending",
    ";mt",
    "tiles_type",
    "finish",
    "limit",
    "available_region",
  ];

  // Old-component branch (any query params)
  if (Object.keys(query).length !== 0) {
    props.oldComponent = true;

    // parse cookies
    cookies = parse(req.headers.cookie || "");
    // build filters from query

    // if we have a pincode cookie
    if (cookies?.pincode) {
      props.fromPincode = true;
      const locationDetail = await getLocationDetail({
        pincode: cookies.pincode,
      });

      for (let f of Object.keys(context.query)) {
        if (f && context.query[f]) {
          if (
            !isNaN(context.query[f].split(",")[0]) &&
            !errorArray.includes(f)
          ) {
            fitterrss = {
              ...fitterrss,
              [f]: {
                in: context.query[f].split(",").map((cur) => Number(cur)),
              },
            };
            fitterrss2 = {
              ...fitterrss2,
              [f]: {
                $in: context.query[f].split(",").map((cur) => Number(cur)),
              },
            };
          }
        }
      }

      // {"tile_size":{"$in":[267]},"tile_category":{"$in":[222]},"tile_factory_production":{"$in":[201]}}
      // console.log(fitterrss2);

      const resp = await axios.post(
        `https://proxy.orientbell.com/api/products?category=${value}&pincode=${cookies.pincode}`,
        fitterrss2
      );
      let ProdBySalesDate = resp.data || [];
      if (locationDetail?.data?.p_location) {
        fitterrss.plocation = { in: [locationDetail.data.p_location.value] };
      }

      props.oldComponentProps = {
        ...props.oldComponentProps,
        fromPincode: true,
        ProdBySalesDate,
        appliedFilters: fitterrss,
        value,
        displayLocationPopop: true,
        categoryValue,
        regionData: locationDetail?.data?.p_location || null,
        fitterrss,
        fitterrss2,
        UnbxdResponse: { numberOfProducts: 0, products: [] },
        facetsUnbxd: {},
        appliedFilterFromUnbxd: {},
      };
    } else {
      // no pincode -> Unbxd branch
      const queryParamsArray = Object.keys(query)
        .filter((k) => k !== "category")
        .map((k) => ({
          [k]: isNaN(query[k]) ? query[k] : Number(query[k]),
        }));

      const pId = `p-id=categoryPathId%3A%22${encodeURIComponent(
        resolvedUrl.split("?")[0]
      )}%22`;
      const extras = `&facet.multiselect=true&spellcheck=true&pagetype=boolean&rows=25&start=0&version=V2&fallback=true&viewType=GRID&facet.version=V2`;
      unBxdProd = await axios.get(`${baseUrl}?${pId}${extras}`);

      facetsUnbxd = unBxdProd.data.facets || null;
      appliedFilterFromUnbxd = queryParamsArray.length
        ? queryParamsArray
        : null;

      props.oldComponentProps = {
        ...props.oldComponentProps,
        fromPincode: false,
        UnbxdResponse: unBxdProd.data.response,
        appliedFilters: appliedFilterFromUnbxd,
        facetsUnbxd,
        displayLocationPopop: true,
        appliedFilterFromUnbxd,
      };
    }

    // handle 404 redirect if needed
    if (
      data?.products?.items?.length === 0 &&
      !data.products.currentcategory.description
    ) {
      return {
        redirect: { destination: "/404", permanent: false },
      };
    }

    props.oldComponentProps = {
      ...props.oldComponentProps,
      categoryValue,
    };
  }

  //  New-component branch (always runs)
  try {
    // run your existing GraphQL fetch for old component

    const [gqlRes, newProd] = await Promise.all([
      // magento query that fetches description and stuff
      client.query({
        query: getProductQueryServerSide,
        variables: {
          filter: fitterrss,
          sort: { recommended: "ASC" },
          pageSize: props.fromPincode ? 14 : 15,
          currentPage: 1,
        },
      }),
      // Unbxd query
      axios.get(`${baseUrl}${unBxdUrl}`),
    ]);

    data = gqlRes.data;
    props.oldComponentProps.data = data;
    let videoSchema = gqlRes?.data?.products?.currentcategory?.videoschema;

    props.oldComponentProps.videoSchema = videoSchema;
    const raw = newProd.data.banner.banners[0].bannerHtml;
    const sizeProductList = mapSizesToProducts(
      raw,
      newProd.data.response.products
    );

    if (!newProd.data.response) throw new Error("No products found");

    props.response = newProd.data.response;
    props.sizeProductList = sizeProductList;
  } catch (err) {
    console.error(err);
    props.error = err.message;
  }

  return { props };
}

export default function Page({
  error,
  oldComponent = false,
  oldComponentProps,
  sizeProductList,
}) {
  const router = useRouter();

  const { data } = oldComponentProps;

  const [oldComponentState, setOldComponentState] = useState(oldComponent);
  const [selected, setSelected] = useState(kitchenTileSections[0].name);

  // Function to relocate to new UI Component
  oldComponentProps = {
    ...oldComponentProps,
    removeAllFilterAndRedirect: () => setOldComponentState(false),
  };

  if (error) return <div>{error}</div>;
  if (oldComponentState) return <Category {...oldComponentProps} />;

  /**
   * Function to create a "view more" link for a given size and type.
   * @param {string} size - The size of the tiles (e.g. "600x600", "600x1200", etc.)
   * @param {string} type - The type of tiles (e.g. "wall", "floor", "counter")
   * @returns {string} The URL for the "view more" link
   */
  const createViewMoreLink = (size, type) => {
    // Determine the size and type for the URL
    let typeLabel;
    switch (type) {
      case "wall":
        typeLabel = "walls-tiles";
        break;
      case "floor":
        typeLabel = "floor-tiles";
        break;
      case "counter":
        typeLabel = "counter-tiles";
        break;
      default:
        // If no type is given, default to "walls-tiles"
        typeLabel = "walls-tiles";
    }

    // Return the URL for the view more link
    return `/tiles/kitchen-tiles/${size}/${typeLabel}`;
  };

  // New UI rendering
  return (
    <>
      <Head>
        <meta charset="utf-8" />
        <meta name="title" content={data.products.currentcategory.meta_title} />
        <title>{data.products.currentcategory.meta_title}</title>
        <meta
          name="description"
          content={data.products.currentcategory.meta_description}
        />
        <meta
          name="keywords"
          content={data.products.currentcategory.meta_keywords}
        />
        {/* <meta name="robots" content="INDEX,FOLLOW"/> */}
        <meta name="format-detection" content="telephone=no" />
        <link
          rel="preconnect dns-prefetch"
          href="https://connect.facebook.net"
          crossorigin=""
        />
        <link
          rel="preconnect dns-prefetch"
          href="https://www.googletagmanager.com"
          crossorigin=""
        />
        <meta
          http-equiv="Accept-CH"
          content="viewport-width, width, device-memory, dpr, downlink, ect"
        />
        <meta name="pinterest-rich-pin" content="false" />
        <meta
          name="twitter:description"
          content={data.products.currentcategory.meta_description}
        />
        <meta
          name="twitter:title"
          content={data.products.currentcategory.meta_title}
        />
        <meta
          name="twitter:image"
          content={`${config.API_ENDPOINT}/media/img/logo.png`}
        />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="Orientbell" />
        <meta name="twitter:creator" content="Orientbell" />
        <meta
          property="og:url"
          content={`${config.HEADLESS_BASE_URL}/tiles/kitchen-tiles`}
        />
        <meta
          property="og:description"
          content={data.products.currentcategory.meta_description}
        />
        <meta
          property="og:title"
          content={data.products.currentcategory.meta_title}
        />
        {/* Video Schema */}
        {oldComponentProps.videoSchema && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: oldComponentProps.videoSchema.replace(
                /<script\s+type="application\/ld\+json">|<\/script>/g,
                ""
              ),
            }}
          />
        )}
        {data.products?.currentcategory?.schema && (
          <>
            {data.products.currentcategory.schema
              .split(/<script[^>]*>/g) // Split by opening <script> tags
              .filter((schema) => schema.trim()) // Filter out any empty strings
              .map((schemaContent, index) => (
                <script
                  key={index} // Use index as the key
                  type="application/ld+json"
                  dangerouslySetInnerHTML={{
                    __html: schemaContent.replace(/<\/script>/g, ""), // Remove closing </script> tag
                  }}
                />
              ))}
          </>
        )}

        <meta
          property="og:image"
          content={`${config.API_ENDPOINT}/media/img/logo.png`}
        />
        <script
          type="text/javascript"
          src="https://cdn.roomvo.com/static/scripts/b2b/orientbell.js"
          defer=""
        ></script>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={webPageSchema(data, router)}
        />
        {/* {Object.keys(videoSchema).length > 0 && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: videoSchema }}
          />
        )} */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={breadsCrumbSchema(
            data.products.currentcategory
          )}
        />
        {/* {pinFromCityPage && <script type="application/ld+json" />} */}
      </Head>

      <section className="category-bathroom-tile-section  new-cate-bath-tile-sect">
        <div className="container container-width">
          <div className="bread-crumb-row">
            <ul>
              <li>
                <a href={config.HEADLESS_BASE_URL}>Home</a>
              </li>
              <li>
                <a href="/tiles">Tiles</a>
              </li>
              {data.products.currentcategory.breadcrumbs &&
                data.products.currentcategory.breadcrumbs.map((bre, inddd) => {
                  if (inddd != 0 && bre.category_name != "All Tiles") {
                    return (
                      <li key={inddd}>
                        <a href={`/${bre.category_url_path}`}>
                          {bre.category_name}
                        </a>
                      </li>
                    );
                  }
                })}
            </ul>
          </div>

          <div className="categry-heading-row">
            <h1>Kitchen Tiles</h1>

            {/* Description from magento */}
            {data.products?.currentcategory.description && (
              <div className="category_accordion_data ">
                <div
                  dangerouslySetInnerHTML={{
                    __html: data.products.currentcategory.description.replace(
                      /<p>\s*<\/p>/g,
                      ""
                    ),
                  }}
                />
              </div>
            )}
          </div>

          {/* Toggle button */}
          <div className="custom-toggle-wrapper">
            <div className="custom-toggle">
              {kitchenTileSections.map((section) => (
                <a
                  href={`#${section.name}-section`}
                  key={section.name}
                  className={`toggle-option ${
                    selected === section.name ? "active" : ""
                  }`}
                  onClick={(e) => {
                    e.preventDefault();
                    setSelected(section.name);
                    scrollToElement(`${section.name}-section`);
                  }}
                >
                  {section.label}
                </a>
              ))}

              {/* Slider animation logic */}
              <div
                className={`toggle-slider`}
                style={{
                  width: `${100 / kitchenTileSections.length}%`,
                  left: `${
                    (100 / kitchenTileSections.length) *
                    kitchenTileSections.findIndex((s) => selected === s.name)
                  }%`,
                }}
              />
            </div>
          </div>

          {kitchenTileSections.map((section, index) => (
            <div
              className="categry-tile-prod-row"
              key={index}
              id={`${section.name}-section`}
            >
              {/* Wall or Floor or Counter  */}
              <div className="exp-tile-text-row">
                <span>
                  {" "}
                  <h2>{section.type}</h2>
                  {(() => {
                    switch (section.name) {
                      case "floor":
                        return (
                          <a href="/tiles/kitchen-tiles/kitchen-floor-tiles">
                            <button className="btn btn-primary">
                              View All
                            </button>
                          </a>
                        );
                      case "wall":
                        return (
                          <a href="/tiles/kitchen-tiles/kitchen-wall-tiles">
                            <button className="btn btn-primary">
                              View All
                            </button>
                          </a>
                        );
                      case "counter":
                        return (
                          <a href="/tiles/kitchen-countertop">
                            <button className="btn btn-primary">
                              View All
                            </button>
                          </a>
                        );
                      default:
                        return (
                          <a href="/tiles/kitchen-tiles">
                            <button className="btn btn-primary">
                              View All
                            </button>
                          </a>
                        );
                    }
                  })()}
                </span>
                <p>{section.description}</p>
              </div>
              <ul className="categry-explore-wrap">
                {sizeProductList[section.name].map((obj, idx) => (
                  <li key={idx}>
                    <div className="categry-explore-size-head">
                      <h3>
                        <span>{obj.size}</span> Kitchen{" "}
                        {/* Wall or Floor or Counter */}
                        {section.label} Tiles
                      </h3>
                    </div>
                    <div className="categry-explore-row">
                      {Array.isArray(obj.product) &&
                        obj.product.map((prod, productIndex) => (
                          <NewProductCard product={prod} key={productIndex} />
                        ))}
                    </div>
                    <div className="explore-pro-btn-row">
                      <a href={createViewMoreLink(obj.size, section.name)}>
                        <button className="btn btn-primary">View More</button>
                      </a>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          ))}
          <div
            className="category_accordion_data"
            dangerouslySetInnerHTML={{
              __html: data.products?.currentcategory.dynamic_content.replace(
                /<p>\s*(&nbsp;)?\s*<\/p>/g,
                ""
              ),
            }}
          />
        </div>
      </section>
    </>
  );
}
